// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3n1u7","noInteraction":"EventWrapper_noInteraction__Oc6Ih"};